﻿import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { PinchZoomModule } from 'ngx-pinch-zoom';

import { BackHeaderComponent } from './back/back-header';
import { BackIconComponent } from './back/back-icon';
import { ElmSvgComponent } from './svg/svg';
import { SelectPictureComponent } from './select-picture/select-picture.component';
import { SelectPictureNewComponent } from './select-picture-new/select-picture-new.component';
import { SelectFileComponent } from './select-file/select-file.component';
import { NewPageSelectComponent } from './new-page-select/new-page-select.component';
import { CorpSelectComponent } from './corp-select/corp-select.component';
import { OrgCascaderComponent } from './org-cascader/org-cascader.component';
import { RejectPageSelectComponent } from './reject-page-select/reject-page-select.component';
import { PopoverDialogComponent } from './popover-dialog/popover-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { ReturnDialogComponent } from './return-dialog/return-dialog.component';
import { FloorPlanDialogComponent } from './floor-plan-dialog/floor-plan-dialog.component';
import { GmpFloorPlanDialogComponent } from './gmp-floor-plan-dialog/gmp-floor-plan-dialog.component';
import { SpinnerComponent } from './spinner/spinner.component'
import { MyTitlePage } from './my-title/my-title.page'
import { NoSourceImgPage } from './no-source-img/no-source-img.page';
import { AddInspectionObjectComponent } from './add-inspection-object/add-inspection-object.component';
import { LazyLoadingSelectComponent } from './lazy-loading-select/lazy-loading-select.component';
import { DropdownModule } from 'primeng/dropdown';
import { SelectVideoComponent } from './select-video/select-video.component';
import { PopoverImageComponent } from './popover-image/popover-image.component';
import { MultiSelectModalComponent } from './multi-select-modal/multi-select-modal.component';
import { TotalFilterModalComponent } from './filter-modals/total-filter-modal/total-filter-modal.component';
import { RiskmapFilterModalComponent } from './filter-modals/riskmap-filter-modal/riskmap-filter-modal.component';
import { ClassificationFormSelectComponent } from './classification-form-select/classification-form-select.component'
import { FabricCanvasCnComponent } from './fabric-canvas-cn/fabric-canvas-cn.component'
import { ImageAnnotatorModalComponent } from './image-annotator-modal/image-annotator-modal.component';
import { RejectDialogComponent } from '../../capa-management/findings-record/findings-record-detail/components/reject-dialog/reject-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { sharedComponentsI18n } from './i18n';
import { mergeFeatureI18n } from '../utils/merge-feature-i18n';

import { ContractorFilterModalComponent } from './filter-modals/contractor-filter-modal/contractor-filter-modal.component';
import { IncidentFilterModalComponent } from './filter-modals/incident-filter-modal/incident-filter-modal.component';
import { CapaRecordFilterModalComponent } from './filter-modals/capa-record-filter-modal/capa-record-filter-modal.component';
import { FindingsRecordFilterModalComponent } from './filter-modals/findings-record-filter-modal/findings-record-filter-modal.component';
import { FormSelectModalComponent } from './filter-modals/form-select-modal/form-select-modal.component';
import { PersonSelectModalComponent } from './filter-modals/person-select-modal/person-select-modal.component';
import { ReportFilterModalComponent } from './filter-modals/report-filter-modal/report-filter-modal.component';
import { PrivacyDialogComponent } from './privacy-dialog/privacy-dialog.component'
import { PrivacyDetailDialogComponent } from './privacy-detail-dialog/privacy-detail-dialog.component'
import { ClassificationSelectComponent } from './classification-select/classification-select.component'
import { OrgSelectModalComponent } from './org-select-modal/org-select-modal.component';

import { PipesModule } from '../../pipes/pipes.module';

// import { DirectivesModule } from '../directives';
const coms: any[] = [
  RejectDialogComponent,
  ImageAnnotatorModalComponent,
  FabricCanvasCnComponent,
  ClassificationFormSelectComponent,
  BackHeaderComponent,
  BackIconComponent,
  ElmSvgComponent,
  SelectPictureComponent,
  SelectPictureNewComponent,
  SelectFileComponent,
  NewPageSelectComponent,
  CorpSelectComponent,
  OrgCascaderComponent,
  RejectPageSelectComponent,
  LazyLoadingSelectComponent,
  PopoverDialogComponent,
  ReturnDialogComponent,
  GmpFloorPlanDialogComponent,
  FloorPlanDialogComponent,
  SpinnerComponent,
  MyTitlePage,
  NoSourceImgPage,
  AddInspectionObjectComponent,
  SelectVideoComponent,
  PopoverImageComponent,
  MultiSelectModalComponent,
  TotalFilterModalComponent,
  RiskmapFilterModalComponent,
  ContractorFilterModalComponent,
  IncidentFilterModalComponent,
  CapaRecordFilterModalComponent,
  FindingsRecordFilterModalComponent,
  FormSelectModalComponent,
  PersonSelectModalComponent,
  ReportFilterModalComponent,
  PrivacyDialogComponent,
  PrivacyDetailDialogComponent,
  ClassificationSelectComponent,
  OrgSelectModalComponent
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    DropdownModule,
    PinchZoomModule,
    PipesModule,
    IonicModule,
    TranslateModule.forChild(),
  ],
  declarations: [
    coms
  ],
  exports: [
    coms
  ],
  entryComponents: [
    RejectDialogComponent,
    ImageAnnotatorModalComponent,
    FabricCanvasCnComponent,
    ClassificationFormSelectComponent,
    NewPageSelectComponent,
    CorpSelectComponent,
    OrgCascaderComponent,
    RejectPageSelectComponent,
    LazyLoadingSelectComponent,
    PopoverImageComponent,
    MultiSelectModalComponent,
    TotalFilterModalComponent,
    RiskmapFilterModalComponent,
    ContractorFilterModalComponent,
    IncidentFilterModalComponent,
    CapaRecordFilterModalComponent,
    FindingsRecordFilterModalComponent,
    FormSelectModalComponent,
    PersonSelectModalComponent,
    GmpFloorPlanDialogComponent,
    FloorPlanDialogComponent,
    ReportFilterModalComponent,
    PrivacyDialogComponent,
    PrivacyDetailDialogComponent,
    ClassificationSelectComponent,
    OrgSelectModalComponent
  ],
})
export class ComponentsModule {
  constructor(private translateService: TranslateService) {
    mergeFeatureI18n(this.translateService, sharedComponentsI18n as any);
  }
}
